__turbopack_context__.v({
  "ctaDetailsContainer": "PlanDetails-module__yYxT2a__ctaDetailsContainer",
  "highlightedSpan": "PlanDetails-module__yYxT2a__highlightedSpan",
});
